export function sliceAwsPath(url) {
  const path = new URL(url).pathname
    .split("/")
    .slice(2)
    .join("/");
  return path;
}
